import { DeleteColumn } from '@/components/DeleteColumn/DeleteColumn';
import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

type DeleteRowColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
  onDeleteClick: (row: T) => void;
  disabledMessage?: string;
};

export const deleteRowColumnConfig = <
  T extends TableRow & { canDelete?: boolean },
>({
  options,
  onDeleteClick,
  disabledMessage,
}: DeleteRowColumnConfig<T>): TableColumn<T> => ({
  id: 'action-delete',
  label: <Trans i18nKey="actions" />,
  sortable: false,
  render: (_, row) => {
    return (
      <DeleteColumn
        disabled={!row.canDelete}
        disabledMessage={disabledMessage}
        onClick={() => onDeleteClick(row)}
      />
    );
  },
  ...options,
});
